import { SettingsSection } from './SettingsSection';
import { DetailTranslationKeys, SettingsKeys, SettingsTranslationKeys } from '../../../api/models/TranslationKeys';
import { SettingsOptionButton } from '../components/SettingsOptionButton';
import { ReminderDeviceSettingKeys } from '../../../api/models/NpvrSettingsKeys';
import { CustomerSettingsApi } from '../../../api/user';
import { Log } from '@lightningjs/sdk';
import { GlobalSettingsKeys } from '../../../api/models/GlobalSettingsKeys';

export class ReminderSection extends SettingsSection {
  /**
   * @param {Backend} backend
   */
  constructor(backend) {
    super(backend, backend.translations.forKey(SettingsTranslationKeys.settings_title_reminder));
    // seconds
    this.startValue = backend.globalSettings.numberValue(GlobalSettingsKeys.reminderDefaultBeforeTime) ?? 0;
    this.loadDefaultPromise = CustomerSettingsApi.value(backend, ReminderDeviceSettingKeys.reminder_before_time)
      .then(r => {
        this.startValue = r.value;
      })
      .catch(e => {
        Log.info('[ReminderSettingsSection]', 'failed to get current set value', e);
      });
  }

  addControls(list) {
    super.addControls(list);

    const minutesStr = this.backend.translations.forKey(DetailTranslationKeys.detail_duration_min);
    const beforeTimes = this.backend.globalSettings.stringArray(SettingsKeys.reminderBeforeTimes) ?? [
      '0',
      '5',
      '10',
      '15',
      '20',
      '30',
    ];
    const reminderBeforeTimes = beforeTimes.map(option => {
      return { value: '' + parseInt(option, 10) * 60, text: `${option} ${minutesStr}` };
    });
    return this.loadDefaultPromise.then(() => {
      let selectedIdx = reminderBeforeTimes.findIndex(v => v.value === this.startValue);
      selectedIdx = selectedIdx === -1 ? 0 : selectedIdx;
      list.items.childList.a({
        type: SettingsOptionButton,
        data: {
          label: this.backend.translations.forKey(SettingsTranslationKeys.settings_reminder_before_time),
          options: reminderBeforeTimes,
          value: reminderBeforeTimes[selectedIdx] ?? null,
          action: ctrl => {
            CustomerSettingsApi.update(
              this.backend,
              ReminderDeviceSettingKeys.reminder_before_time,
              ctrl.data.value.value
            )
              .catch(e => Log.error('[ReminderSettingsSection]', 'failed to set setting', e))
              .then(() => {
                // update cache to new customer setting so next reminder has correct time
                this.backend.cachedReminderApi.updateReminderBeforeTime(ctrl.data.value.value);
              });
          },
        },
        passSignals: {
          onActivate: true,
        },
      });
    });
  }
}
